import Vue from 'vue'
import VueRouter from 'vue-router'
// import strategy from '../views/strategy.vue'
// import informationDetail from '@/components/strategy/informationDetail'
// import market from '@/views/market'
// import newsFlash from "@/views/newsFlash"
// import userCenter from "@/views/userCenter"
// import strategyList from "@/components/strategy/strategyList";
// import information from "@/components/strategy/information";
// import strategyDetail from "@/components/strategy/strategyDetail";

//路由懒加载
const strategy = () => import(('@/views/strategy'))
const informationDetail = () => import((`@/components/strategy/informationDetail`))
const market = () => import((`@/views/market`))
const newsFlash = () => import((`@/views/newsFlash`))
const userCenter = () => import((`@/views/userCenter`))
const strategyList = () => import((`@//components/strategy/strategyList`))
const information = () => import((`@/components/strategy/information`))
const strategyDetail = () => import((`@/components/strategy/strategyDetail`))
const advertisement = () => import((`@/components/advertisement/advertisement`))
const within = () => import((`@/components/market/within`))
const outside = () => import((`@/components/market/outside`))
const theme = () => import((`@/components/market/theme`))
const newsFlashList = () => import((`@/components/newsFlash/newsFlashList`))
const calendar = () => import((`@/components/newsFlash/calendar`))
const calendarDataDetail = () => import((`@/components/newsFlash/calendarDataDetail`))
const chart = () => import((`@/components/market/chart`))
const login = () => import((`@/components/login/login`))
const password = () => import((`@/components/login/password`))
const userAgreement = () => import((`@/components/login/userAgreement`))
const collection = () => import((`@/components/userCenter/collection`))
const subscribe = () => import((`@/components/userCenter/subscribe`))
const modify = () => import((`@/components/userCenter/modify`))
const cut = () => import((`@/components/userCenter/cut`))
const forget = () => import((`@/components/login/forget`))


Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace

//push
// @ts-ignore
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    // @ts-ignore
    return originalPush.call(this, location).catch(err => err)
}
//replace
// @ts-ignore
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
    // @ts-ignore
    return originalReplace.call(this, location).catch(err => err)
}


const routes = [
    {
        path: '/',
        name: 'Index',
        redirect: "/strategy/information",
    },
    {
        path: '/strategy',
        name: 'strategy',
        component: strategy,
        children: [
            {
                path: 'information',
                component: information,
            },
            {
                path: 'strategy',
                component: strategyList,
            }
        ]
    },
    {
        path: '/informationDetail',
        name: 'informationDetail',
        component: informationDetail,
    },
    {
        path: '/strategyDetail',
        name: 'strategyDetail',
        component: strategyDetail,
    },
    {
        path: '/market',
        name: 'market',
        component: market,
        children: [
            {
                path: 'within',
                component: within,
            },
            {
                path: 'outside',
                component: outside,
            },
            {
                path: 'theme',
                component: theme,
            },
        ]
    },
    {
        path: '/newsFlash',
        name: 'newsFlash',
        component: newsFlash,
        children: [
            {
                path: 'newsFlash',
                component: newsFlashList,
            },
            {
                path: 'calendar',
                component: calendar,
            },
        ]
    },
    {
        path: '/userCenter',
        name: 'userCenter',
        component: userCenter,


    },
    {
        path: '/advertisement',
        name: 'advertisement',
        component: advertisement,
    },
    {
        path: '/calendarDataDetail',
        name: 'calendarDataDetail',
        component: calendarDataDetail,
    },
    {
        path: '/chart',
        name: 'chart',
        component: chart,
    },
    {
        path: '/login',
        name: 'login',
        component: login,
    },
    {
        path: '/loginPW',
        name: 'loginPW',
        component: password,
    },
    {
        path: '/userAgreement',
        name: 'userAgreement',
        component: userAgreement,
    },
    {
        path: '/collection',
        name: 'collection',
        component: collection,
    },
    {
        path: '/subscribe',
        name: 'subscribe',
        component: subscribe,
    },
    {
        path: '/modify',
        name: 'modify',
        component: modify,
    },
    {
        path: '/cut',
        name: 'cut',
        component: cut,
    },
    {
        path: '/forget',
        name: 'forget',
        component: forget,
    },
    {
        path: "*",
        redirect: "/"
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
